import { render, staticRenderFns } from "./BotSettingsForm.vue?vue&type=template&id=7e9a126c&scoped=true&"
import script from "./BotSettingsForm.vue?vue&type=script&lang=js&"
export * from "./BotSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./BotSettingsForm.vue?vue&type=style&index=0&id=7e9a126c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9a126c",
  null
  
)

export default component.exports